import header from "./man-thinking.png";
import section1 from "./female-couple-talking-floorplan.png";
import section2 from "./man-is-studying-floorplan.png";
import section3 from "./floorplan.webp";
import section4 from "./ausschnitte-eines-grundrisses.png";
import section5 from "./woman-holding-floorplan.webp";
import section6 from "./zusammen-planen.webp";
import section7 from "./happy-woman.webp";
import section8 from "./skizze-haus.png";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
};
